<template>
  <config-provider v-bind="antProvideProps">
    <div id="app">
      <router-view />
      <CallingPanel />
      <Spin
        v-show="globalSpin.loading"
        class="fixed-cover-root"
        :tip="globalSpin.tip"
        :loading="globalSpin.loading"
      >
        <Icon
          slot="indicator"
          type="loading"
          style="font-size: 40px;margin-bottom: 16px;"
          spin
        />
      </Spin>
    </div>
  </config-provider>
</template>

<script>
import { ConfigProvider, Spin, Icon } from 'ant-design-vue'

import CallingPanel from '@/components/business/calling-panel/index.vue'
import { mapState } from 'vuex'

import I18nMixin from '@/i18n/mixin.vue'

import Global from '@/global'
export default {
  name: 'HiLeia5',
  mixins: [I18nMixin],
  components: {
    ConfigProvider,
    CallingPanel,
    Spin,
    Icon
  },
  computed: {
    ...mapState(['globalSpin'])
  },
  created(){
    console.log(Global.VERSION)
  }
}
</script>
